import type { SupStoredTxSettings } from "@/types";

import React, { type Dispatch, type SetStateAction } from "react";

import { SupTabPanel, SupScrollable } from "@repo/core-ui";
import Web3TxSettingsGroupRetainVaultShares from "@/components/Web3/TxSettings/Group/RetainVaultShares";
import Web3TxSettingsGroupRouteType from "@/components/Web3/TxSettings/Group/RouteType";
import Web3TxSettingsGroupService from "@/components/Web3/TxSettings/Group/Service";
import Web3TxSettingsGroupSlippage from "@/components/Web3/TxSettings/Group/Slippage";

interface Web3TxSettingsTabRoutesProps {
  settings: SupStoredTxSettings;
  setSettings: Dispatch<SetStateAction<SupStoredTxSettings>>;
}

export default function Web3TxSettingsTabRoutes({ setSettings, settings }: Web3TxSettingsTabRoutesProps) {
  return (
    <SupTabPanel className="py-4" unmountOnExit value="routes">
      <SupScrollable className="scrollbar-custom max-h-[calc(90vh-250px)]" orientation="vertical" contentClassName="space-y-6">
        <Web3TxSettingsGroupSlippage setSettings={setSettings} settings={settings} />
        <Web3TxSettingsGroupRouteType setSettings={setSettings} settings={settings} />
        <Web3TxSettingsGroupRetainVaultShares setSettings={setSettings} settings={settings} />

        <Web3TxSettingsGroupService type="ambs" setSettings={setSettings} settings={settings} />
        <Web3TxSettingsGroupService type="liquidity_providers" setSettings={setSettings} settings={settings} />
        <Web3TxSettingsGroupService type="bridges" setSettings={setSettings} settings={settings} />
        <Web3TxSettingsGroupService type="dexes" setSettings={setSettings} settings={settings} />
      </SupScrollable>
    </SupTabPanel>
  );
}
